import type { TourDefinition } from "@/types/tour";

export const postCommitteeTour: TourDefinition = {
  id: "post-committee-assembly",
  context: "terminus-admin",
  version: 1,
  // Trailing slash → prefix match: fires on the per-committee assembly detail.
  path: "/post-committee/",
  steps: [
    {
      element: '[data-tour-id="postcommittee-carousel"]',
      popover: {
        title: "One opportunity at a time",
        description:
          "Page through this committee's approved opportunities with the arrows. The summary shows how many are left to assign and how many are already in project leads.",
      },
    },
    {
      element: '[data-tour-id="postcommittee-focused"]',
      popover: {
        title: "The focused opportunity",
        description:
          "Review the opportunity in focus — its sector, owner, strategic fit, and its approved solutions.",
      },
    },
    {
      element: '[data-tour-id="postcommittee-reshape"]',
      popover: {
        title: "Reshape it",
        description:
          "Split the opportunity's solutions into a new one, or merge it with another same-sector opportunity. Both keep a lineage trail.",
      },
    },
    {
      element: '[data-tour-id="postcommittee-assign"]',
      popover: {
        title: "Assign to a project lead",
        description:
          "Send the focused opportunity into a project lead — pick an existing one or create a new container. Assigned opportunities drop out of the carousel; rejecting one drops it too.",
      },
    },
  ],
};
